function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Polonium-logo");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffffff",
  d: "M8.2,0.5H0.7v15.8h3.9v-4.5h3.7c3.4,0,6.1-2.3,6.1-5.6C14.3,2.7,11.6,0.5,8.2,0.5 M7.9,8.6H4.5V3.7     h3.4c1.4,0,2.4,1,2.4,2.4C10.3,7.5,9.4,8.6,7.9,8.6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ffffff",
  points: "48.7,16.2 36.8,16.2 36.8,0.5 40.6,0.5 40.6,13 48.7,13 "
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ffffff",
  points: "74.9,16.2 71.1,16.2 71.1,0.5 74.4,0.5 82.5,10.1 82.5,0.5 86.4,0.5 86.4,16.2 83,16.2      74.9,6.7 "
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ffffff",
  points: "90.2,16.4 94.1,16.4 94.1,0.7 90.2,0.7 "
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffffff",
  d: "M98.9,0.5h3.9v9.9c0,2,1.4,2.8,3.2,2.8c1.9,0,3.2-0.9,3.2-2.8V0.5h3.9v10.1c0,4.2-3.4,5.9-7,5.9     c-4,0-7-1.9-7-5.9V0.5z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ffffff",
  points: "132.3,0.5 126.7,7.1 121.1,0.5 117.8,0.5 117.8,16.2 121.7,16.2 121.7,6.4 126.5,11.8      126.9,11.8 131.7,6.4 131.7,16.2 135.6,16.2 135.6,0.5 "
});

var _ref9 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ffffff",
  points: "0.4,19.3 0.4,31.8 3.5,31.8 3.5,26.8 8.3,26.8 8.3,24.2 3.5,24.2 3.5,21.8 9.7,21.8      9.7,19.3 "
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffffff",
  d: "M28.2,19.3h3.1v7.9c0,1.6,1.1,2.2,2.5,2.2c1.5,0,2.5-0.7,2.5-2.2v-7.9h3.1v8     c0,3.3-2.7,4.7-5.6,4.7c-3.2,0-5.6-1.5-5.6-4.7V19.3z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ffffff",
  points: "51.9,19.3 51.9,26.9 45.4,19.3 42.8,19.3 42.8,31.8 45.9,31.8 45.9,24.2 52.3,31.8      55,31.8 55,19.3 "
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffffff",
  d: "M64.1,19.3h-5.6v12.6h5.6c4,0,6.5-2.3,6.5-6.3C70.6,21.5,68.2,19.3,64.1,19.3 M63.8,29.3h-2.2     v-7.4h2.2c2.4,0,3.6,1.2,3.6,3.7C67.4,27.9,66.3,29.3,63.8,29.3"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffffff",
  d: "M77.4,19.3l-5,12.6h3.3l0.9-2.3h5.4l0.9,2.3h3.3l-5-12.6H77.4z M79.2,22.3l1.8,4.8h-3.6L79.2,22.3     z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ffffff",
  points: "86.4,19.3 86.4,21.9 90.1,21.9 90.1,31.8 93.2,31.8 93.2,21.9 97,21.9 97,19.3 "
});

var _ref15 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ffffff",
  points: "99.6,31.8 102.7,31.8 102.7,19.3 99.6,19.3 "
});

var _ref16 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#ffffff",
  points: "132.5,19.3 132.5,26.9 126,19.3 123.4,19.3 123.4,31.8 126.5,31.8 126.5,24.2 132.9,31.8      135.6,31.8 135.6,19.3 "
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffffff",
  d: "M59.6,0.2c-4.5,0-8.2,3.6-8.2,8.1c0,4.5,3.7,8.1,8.2,8.1s8.2-3.6,8.2-8.1     C67.8,3.9,64.1,0.2,59.6,0.2 M59.6,12.5c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2     C63.8,10.7,61.9,12.5,59.6,12.5"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffffff",
  d: "M113.2,19.1c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5c3.6,0,6.5-2.9,6.5-6.5S116.8,19.1,113.2,19.1     M113.2,28.8c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3S115,28.8,113.2,28.8"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FF4750",
  d: "M24.5,0c-4.5,0-8.2,3.6-8.2,8.1c0,2.6,1.3,5,3.2,6.4l-1.7,4.4c-0.1,0-0.2,0-0.3,0     c-3.6,0-6.5,2.9-6.5,6.5c0,3.6,2.9,6.4,6.5,6.4s6.5-2.9,6.5-6.4c0-2.2-1.1-4.1-2.8-5.3l1.6-4c0.6,0.1,1.1,0.2,1.7,0.2     c4.5,0,8.2-3.6,8.2-8.1S29.1,0,24.5,0 M17.5,28.7c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3     C20.9,27.2,19.4,28.7,17.5,28.7 M24.5,12.3c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2     C28.7,10.4,26.9,12.3,24.5,12.3"
});

var SvgPoloniumLogo = function SvgPoloniumLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 136 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPoloniumLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/polonium-logo.1ca8c18c.svg";
export { ForwardRef as ReactComponent };